<!--DONE-->
<ng-template #actionMenu let-actionData>
	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData[0]" (click)="browseMoreAnswers(actionData)" type="button" kind="ghost" description="Browse Next Value" [align]="actionData[0].includes('Asset Name') && actionData[0].includes('Fund')? 'bottom-left' : 'top-left'">
		<svg class="cds--btn__icon" cdsIcon="choose-item" size="16"></svg>
	</ibm-icon-button>
	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData[0]" (click)="editExtractedValue(actionData)" type="button" kind="ghost" description="Edit Extracted Value" [align]="actionData[0].includes('Asset Name') && actionData[0].includes('Fund') ? 'bottom' : 'top'">
		<svg class="cds--btn__icon" cdsIcon="edit" size="16"></svg>
	</ibm-icon-button>
	<ibm-icon-button *ngIf="(this.hoveringOverItem === actionData[0] || actionData[1]['Checked']) && !editFieldModalOpen" (click)="confirmAsAccurate(actionData)" type="button" kind="ghost" description="Confirm as Accurate" [align]="actionData[0].includes('Asset Name') && actionData[0].includes('Fund') ? 'bottom-right' : 'top-right'">
		<svg class="cds--btn__icon" cdsIcon="checkmark" size="16"></svg>
	</ibm-icon-button>
</ng-template>


<ng-template #overflowMenu let-index>
  <ibm-tooltip class="cds--icon-tooltip" description="Edit Portfolio Assets" [align]="'left'">
    <ibm-overflow-menu
		description=""
      [flip]="true"
      triggerClass="cds--toolbar-action"
      [offset]="{ x: 0, y: index > this.extractedData['Portfolio Assets'].length - 5 ? -208 : 0 }"
	  (click)="doNothing($event)"
    >
      <ibm-overflow-menu-option (click)="editAssetname(index)">Edit Asset Name</ibm-overflow-menu-option>
      <ibm-overflow-menu-option (click)="addAssetAbove(index)">Add Above</ibm-overflow-menu-option>
      <ibm-overflow-menu-option (click)="addAssetBellow(index)">Add Below</ibm-overflow-menu-option>
      <ibm-overflow-menu-option (click)="onClickRemoveAsset(index)" [divider]="true" type="danger">
        Delete
      </ibm-overflow-menu-option>
    </ibm-overflow-menu>
  </ibm-tooltip>
</ng-template>

<div id="data-container" *ngIf="this.page === 'file-data' && this.currentFileData" @fadeInUp class="row data-container" style="overflow-y: hidden">
	<div id="data-panel" (click)="doNothing($event)" (mouseleave)="enteringItem(null)">
		<div *ngIf="this.extractedData.hasOwnProperty('Fund')">
			<cds-contained-list [label]="getListTitle(this.extractedData['Fund'])">
				<cds-contained-list-item
					[clickable]="true"
					[action]="actionMenu"
					(mouseleave)="enteringItem(null)"
					(mouseenter)="enteringItem('Fund|' + key)"
					[actionData]="['Fund|' + key, this.extractedData['Fund'][key]]"
					*ngFor="let key of Object.keys(this.extractedData['Fund']).sort()"
					(click)="renderBoundingBox($event, 'Fund', key, this.extractedData['Fund'][key])"
				>
					<ng-container *ngIf="!isPeriodicValue(key, this.extractedData['Fund'][key]['Value'])" ibmContainedListItemButton>
						<div style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
							<span>{{key.slice(4)}}</span>
							<span>{{getValue(this.extractedData['Fund'][key])}}</span>
							<span *ngIf="this.extractedData['Fund'][key]['Votes']">
								<cds-tag [type]="this.getTagType(this.extractedData['Fund'][key])" [size]="'sm'">
									{{this.getTagText(this.extractedData['Fund'][key])}}
								</cds-tag>
							</span>
						</div>
					</ng-container>
					<ng-container *ngIf="isPeriodicValue(key, this.extractedData['Fund'][key]['Value'])" ibmContainedListItemButton>
						<div style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
							<span>{{key.slice(4)}}</span>
							<span></span>
							<span *ngIf="this.extractedData['Fund'][key]['Votes']">
								<cds-tag [type]="this.getTagType(this.extractedData['Fund'][key])" [size]="'sm'">
									{{this.getTagText(this.extractedData['Fund'][key])}}
								</cds-tag>
							</span>
						</div>
						<div *ngFor="let amountPeriod of getValue(this.extractedData['Portfolio Assets'][displayAssetIndex][key]).split(' | ')" style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
							<span>{{amountPeriod.split(' - ')[0]}}</span>
							<span>{{amountPeriod.split(' - ')[1]}}</span>
							<span></span>
						</div>
					</ng-container>
				</cds-contained-list-item>
			</cds-contained-list>

			<cds-contained-list label='Seller LP Position' *ngIf="this.extractedData['Limited Partner']">
				<cds-contained-list-item
					[clickable]="true"
					[action]="actionMenu"
					(mouseleave)="enteringItem(null)"
					(mouseenter)="enteringItem('Limited Partner|' + key)"
					[actionData]="['Limited Partner|' + key, this.extractedData['Limited Partner'][key]]"
					*ngFor="let key of Object.keys(this.extractedData['Limited Partner']).sort()"
					(click)="renderBoundingBox($event, 'Limited Partner', key, this.extractedData['Limited Partner'][key])"
				>
					<ng-container ibmContainedListItemButton>
						<div style="display: grid; columnGap: 0.5rem; gridTemplateColumns: 5fr 5fr minmax(40px, 2fr);">
							<span>{{key.slice(4)}}</span>
							<span>{{getValue(this.extractedData['Limited Partner'][key])}}</span>
							<span *ngIf="this.extractedData['Limited Partner'][key]['Votes']">
								<cds-tag [type]="this.getTagType(this.extractedData['Limited Partner'][key])" [size]="'sm'">
									{{this.getTagText(this.extractedData['Limited Partner'][key])}}
								</cds-tag>
							</span>
						</div>
					</ng-container>
				</cds-contained-list-item>
			</cds-contained-list>

			<div *ngIf="Array.isArray(this.extractedData['Portfolio Assets']) && this.extractedData['Portfolio Assets'].length > 0">
				<cds-contained-list [label]="expandPortfolioAsset && showAssetName ? (displayAssetIndex + 1).toString() + '. ' + this.extractedData['Portfolio Assets'][displayAssetIndex]['000-Asset Name']['Value'] : this.extractedData['Portfolio Assets'].length.toString() + ' Portfolio Assets'" *ngIf="this.extractedData['Portfolio Assets']">
					<cds-contained-list-item
						[clickable]=true
						[action]="overflowMenu"
						[actionData]="i"
						*ngFor="let _ of this.extractedData['Portfolio Assets']?.slice(0, displayAssetIndex + 1); let i = index"
						(click)="changeDisplayAssetIndex(i, $event)"
						[id]="'Asset ' + i.toString()"
					>
						<ng-container ibmContainedListItemButton>
							<div style="font-weight: 700">
								{{(i + 1).toString() + '. ' + this.extractedData['Portfolio Assets'][i]['000-Asset Name']['Value']}}
							</div>
						</ng-container>
					</cds-contained-list-item>

					<div *ngIf="expandPortfolioAsset" id="expand-container">
						<cds-contained-list-item
							[clickable]="true"
							[action]="actionMenu"
							(mouseleave)="enteringItem(null)"
							(click)="renderBoundingBox($event, this.extractedData['Portfolio Assets'][displayAssetIndex]['000-Asset Name']['Value'], key, this.extractedData['Portfolio Assets'][displayAssetIndex][key])"
							*ngFor="let key of Object.keys(this.extractedData['Portfolio Assets'][displayAssetIndex]).sort(); let i = index"
							(mouseenter)="enteringItem(this.extractedData['Portfolio Assets'][displayAssetIndex]['000-Asset Name']['Value'] + '|' + key)"
							[actionData]="[this.extractedData['Portfolio Assets'][displayAssetIndex]['000-Asset Name']['Value'] + '|' + key, this.extractedData['Portfolio Assets'][displayAssetIndex][key]]"
						>
							<ng-container *ngIf="!isPeriodicValue(key, this.extractedData['Portfolio Assets'][displayAssetIndex][key]['Value'])" ibmContainedListItemButton>
								<div style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
									<span>{{key.slice(4)}}</span>
									<span>{{getValue(this.extractedData['Portfolio Assets'][displayAssetIndex][key])}}</span>
									<span *ngIf="this.extractedData['Portfolio Assets'][displayAssetIndex][key]['Votes']">
										<cds-tag [type]="this.getTagType(this.extractedData['Portfolio Assets'][displayAssetIndex][key])" [size]="'sm'">
											{{this.getTagText(this.extractedData['Portfolio Assets'][displayAssetIndex][key])}}
										</cds-tag>
									</span>
								</div>
							</ng-container>
							<ng-container *ngIf="isPeriodicValue(key, this.extractedData['Portfolio Assets'][displayAssetIndex][key]['Value'])" ibmContainedListItemButton>
								<div style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
									<span>{{key.slice(4)}}</span>
									<span></span>
									<span *ngIf="this.extractedData['Portfolio Assets'][displayAssetIndex][key]['Votes']">
										<cds-tag [type]="this.getTagType(this.extractedData['Portfolio Assets'][displayAssetIndex][key])" [size]="'sm'">
											{{this.getTagText(this.extractedData['Portfolio Assets'][displayAssetIndex][key])}}
										</cds-tag>
									</span>
								</div>
								<div *ngFor="let amountPeriod of getValue(this.extractedData['Portfolio Assets'][displayAssetIndex][key]).split(' | ')" style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
									<span>{{amountPeriod.split(' - ')[0]}}</span>
									<span>{{amountPeriod.split(' - ')[1]}}</span>
									<span></span>
								</div>
							</ng-container>
						</cds-contained-list-item>
					</div>

					<cds-contained-list-item
						[clickable]=true
						[action]="overflowMenu"
						[actionData]="displayAssetIndex + 1 + i"
						*ngFor="let _ of this.extractedData['Portfolio Assets']?.slice(displayAssetIndex + 1); let i = index"
						(click)="changeDisplayAssetAndScrollBottom(i, $event)"
						[id]="'Asset ' + (displayAssetIndex + i + 1).toString()"
					>
						<ng-container ibmContainedListItemButton>
							<div style="font-weight: 700">
								{{(displayAssetIndex + i + 2).toString() + '. ' + this.extractedData['Portfolio Assets'][displayAssetIndex + i + 1]['000-Asset Name']['Value']}}
							</div>
						</ng-container>
					</cds-contained-list-item>
				</cds-contained-list>
			</div>

			<div *ngIf="Array.isArray(this.extractedData['Transactions'])">
				<cds-contained-list [label]="this.extractedData['Transactions'].length.toString() + ' Transactions'" *ngIf="this.extractedData['Transactions']">
					<cds-contained-list-item
						[clickable]=true
						*ngFor="let _ of this.extractedData['Transactions']?.slice(0, displayAssetIndex + 1); let i = index"
						(click)="changeDisplayAssetIndex(i, $event)"
						[id]="'Asset ' + i.toString()"
					>
						<ng-container ibmContainedListItemButton>
							<div style="font-weight: 700">
								{{(i + 1).toString() + '. ' + this.extractedData['Transactions'][i]['000-Holding Name']['Value']}}
							</div>
						</ng-container>
					</cds-contained-list-item>

					<div *ngIf="expandPortfolioAsset">
						<cds-contained-list-item
							[clickable]="true"
							[action]="actionMenu"
							(mouseleave)="enteringItem(null)"
							(click)="renderBoundingBox($event, this.extractedData['Transactions'][displayAssetIndex]['000-Holding Name']['Value'], key, this.extractedData['Transactions'][displayAssetIndex][key])"
							*ngFor="let key of Object.keys(this.extractedData['Transactions'][displayAssetIndex]).sort(); let i = index"
							(mouseenter)="enteringItem(this.extractedData['Transactions'][displayAssetIndex]['000-Holding Name']['Value'] + '|' + key)"
							[actionData]="[this.extractedData['Transactions'][displayAssetIndex]['000-Holding Name']['Value'] + '|' + key, this.extractedData['Transactions'][displayAssetIndex][key]]"
						>
							<ng-container *ngIf="!isPeriodicValue(key, this.extractedData['Transactions'][displayAssetIndex][key]['Value'])" ibmContainedListItemButton>
								<div style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
									<span>{{key.slice(4)}}</span>
									<span>{{getValue(this.extractedData['Transactions'][displayAssetIndex][key])}}</span>
									<span *ngIf="this.extractedData['Transactions'][displayAssetIndex][key]['Votes']">
										<cds-tag [type]="this.getTagType(this.extractedData['Transactions'][displayAssetIndex][key])" [size]="'sm'">
											{{this.getTagText(this.extractedData['Transactions'][displayAssetIndex][key])}}
										</cds-tag>
									</span>
								</div>
							</ng-container>
							<ng-container *ngIf="isPeriodicValue(key, this.extractedData['Transactions'][displayAssetIndex][key]['Value'])" ibmContainedListItemButton>
								<div style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
									<span>{{key.slice(4)}}</span>
									<span></span>
									<span *ngIf="this.extractedData['Transactions'][displayAssetIndex][key]['Votes']">
										<cds-tag [type]="this.getTagType(this.extractedData['Transactions'][displayAssetIndex][key])" [size]="'sm'">
											{{this.getTagText(this.extractedData['Transactions'][displayAssetIndex][key])}}
										</cds-tag>
									</span>
								</div>
								<div *ngFor="let amountPeriod of getValue(this.extractedData['Transactions'][displayAssetIndex][key]).split(' | ')" style="display: grid; gridTemplateColumns: 5.5fr 5.5fr 2fr; columnGap: 1rem">
									<span>{{amountPeriod.split(' - ')[0]}}</span>
									<span>{{amountPeriod.split(' - ')[1]}}</span>
									<span></span>
								</div>
							</ng-container>
						</cds-contained-list-item>
					</div>

					<cds-contained-list-item
						[clickable]=true
						*ngFor="let _ of this.extractedData['Transactions']?.slice(displayAssetIndex + 1); let i = index"
						(click)="changeDisplayAssetIndex(this.displayAssetIndex + 1 + i, $event)"
						[id]="'Asset ' + (displayAssetIndex + i + 1).toString()"
					>
						<ng-container ibmContainedListItemButton>
							<div style="font-weight: 700">
								{{(displayAssetIndex + i + 2).toString() + '. ' + this.extractedData['Transactions'][displayAssetIndex + i + 1]['000-Holding Name']['Value']}}
							</div>
						</ng-container>
					</cds-contained-list-item>
				</cds-contained-list>
			</div>
		</div>
	</div>

	<div id="pdf-panel" style="overflow-y: hidden; border: none !important">

<!--			DONE-->
		<div @fadeInUp *ngIf="!showSpinner" style="overflow-y: hidden; margin-top: -1px !important; top: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; border: none !important">
			<cds-pagination
				style="margin-top: -1px; border: none !important"
				[model]="paginationModel"
				(selectPage)="scrollToPage($event)"
			></cds-pagination>
			<div id="pdf-container">
				<div *ngFor="let img of this.currentFileData['Pages']; let i = index">
					<img alt="Highlighted Page" [id]="'page-' + i" *ngIf="i === highlightedPage && highlightedPageData" [src]="highlightedPageData">
					<img alt="Non-Highlighted Page" [id]="'page-' + i" *ngIf="i !== highlightedPage && img['Page URL']" [src]="img['Page URL']">
				</div>
			</div>
		</div>

		<!--			DONE-->
		<div id="pdf-loader" *ngIf="showSpinner">
			<cds-loading
				@fadeIn
				size=normal
				[overlay]="false"
				[isActive]="showSpinner"
			></cds-loading>
		</div>

	</div>
</div>

<cds-modal style="z-index: 99999" @fadeInUp *ngIf="editFieldModalOpen" size="sm" [open]="editFieldModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Edit {{this.fieldName.slice(4)}}
		</h3>
	</cds-modal-header>
	<section cdsModalContent [hasForm]="true">
		<cds-text-label [invalid]="fieldValueInvalid" [invalidText]="fieldValueInvalidText">
			Value
			<input name="editBox" (keyup)="onKeyUpEditField($event)" [(ngModel)]="fieldValue" cdsText>
		</cds-text-label>
		<cds-number
			style="margin-top: 8px"
			label="Page"
			[min]="1"
			[max]="this.currentFileData['Pages'].length"
			[step]="1"
			[invalid]="pageNumInvalid"
			[invalidText]="pageNumInvalidText"
			[(ngModel)]="fieldPage"
			(change)="updatePageNum($event)"
		></cds-number>
	</section>
	<cds-modal-footer>
		<button class="cds--btn cds--btn--secondary" (click)="onCloseModal()">
			Cancel
		</button>
		<button class="cds--btn cds--btn--primary" (click)="onSaveClick()">
			Save
		</button>
	</cds-modal-footer>
</cds-modal>

<cds-modal style="z-index: 99999" @fadeInUp *ngIf="removeAssetModalOpen" size="sm" [open]="removeAssetModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Delete {{this.extractedData['Portfolio Assets'][this.indexOfAssetToRemove]['000-Asset Name']['Value']}}
		</h3>
	</cds-modal-header>
	<section cdsModalContent [hasForm]="true">
		Are you sure you want to delete {{this.extractedData['Portfolio Assets'][this.indexOfAssetToRemove]['000-Asset Name']['Value']}}? This action cannot be undone.
	</section>
	<cds-modal-footer>
		<button class="cds--btn cds--btn--secondary" (click)="removeAssetModalOpen = false">
			Cancel
		</button>
		<button class="cds--btn cds--btn--danger" (click)="confirmDeleteAsset()">
			Delete
		</button>
	</cds-modal-footer>
</cds-modal>

<cds-modal style="z-index: 99999" @fadeInUp *ngIf="addAssetModalOpen" size="sm" [open]="addAssetModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Add Portfolio Asset
		</h3>
	</cds-modal-header>
	<section cdsModalContent [hasForm]="true">
		<cds-text-label [invalid]="addAssetNameInvalid" [invalidText]="addAssetnameInvalidText">
			Asset Name
			<input name="editBox" (keyup)="onKeyUpAddAssetName($event)" [(ngModel)]="addAssetName" cdsText>
		</cds-text-label>
	</section>
	<cds-tooltip
		align="bottom-right"
		[isOpen]="false"
		description="This may take a few minutes. Please stay on this page while we extract portfolio asset data."
	>
		<cds-modal-footer>
			<button class="cds--btn cds--btn--secondary" (click)="addAssetModalOpen = false">
				Cancel
			</button>
			<button cdsButton class="cds--btn cds--btn--primary" (click)="onSaveAddAsset()">
				Add Portfolio Asset
			</button>
		</cds-modal-footer>
	</cds-tooltip>
</cds-modal>
